const cardSituation = Object.freeze({
  ATIVO: 'ATIVO',
  GANHO: 'GANHO',
  PERDIDO: 'PERDIDO',
  FINALIZADO: 'FINALIZADO'
})

export default cardSituation



// WEBPACK FOOTER //
// ./src/enums/enumCardSituation.js